<template>
  <div class="q-mt-xl container">
    <div class="col-12">
      <div>
        <q-linear-progress
          size="xs"
          class="q-mt-sm"
          v-if="loading"
          indeterminate
        />

        <q-table
          :grid="$q.screen.lt.sm"
          :rows="listaProdutos"
          color="primary"
          :columns="columns"
          dense
          row-key="code"
          class="sticky-header-table"
          flat
          v-model:pagination="pagination"
          :rows-per-page-options="[10, 20, 50, 100]"
          :virtual-scroll="true"
          :virtual-scroll-sticky-size-start="48"
          hide-bottom
        >
          <template v-slot:no-data="props">
            <div
              v-if="props"
              style="background-color: transparent"
              class="full-width row flex-center q-gutter-sm q-mt-sm"
            >
              <q-img
                src="./../../../assets/tabelSemDados.svg"
                style="height: 170px; width: 150px"
              />
            </div>
          </template>
          <template v-slot:top-right>
            <div class="row q-gutter-sm">
              <div>
                <q-input
                  rounded
                  outlined
                  dense
                  debounce="300"
                  v-model="filtrarProduto"
                  type="text"
                  placeholder="Pesquisar"
                >
                  <template v-slot:append>
                    <q-icon name="search" />
                  </template>
                </q-input>
              </div>
            </div>
          </template>
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Selecione os Produtos para Requisição
            </span>
          </template>
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
              <div class="row card">
                <div class="col-3 q-mr-sm text-center q-mt-md">
                  <div
                    v-if="
                      props.row.product_images &&
                      props.row.product_images.length != 0
                    "
                    class="img-container-grid q-ml-sm"
                  >
                    <q-img
                      v-if="props.row.product_images.length != 0"
                      :src="props.row.product_images[0].url"
                      fit="contain"
                      class="img-grid"
                    />
                  </div>
                  <div class="img-container-grid q-ml-sm" v-else>
                    <span class="img-grid"></span>
                  </div>
                </div>
                <div class="col">
                  <q-card-section class="row text-brand-5 text-grid-table">
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Código:</strong> {{ props.row?.code }}</span
                      >
                      <span class="q-ml-sm"
                        ><strong>Nome:</strong> {{ props.row?.name }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>CA:</strong>
                        {{ props.row.ca_codigo || "-" }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Estoque:</strong>
                        {{ formatarEstoque(props.row) }}</span
                      >
                    </div>
                    <div class="col-12">
                      <div class="col-12">
                        <div class="text-brand-5 btn-grid-container">
                          <div class="row col-12 items-center">
                            <div class="q-mr-sm">
                              <q-icon
                                name="arrow_left"
                                class="arrow"
                                style="background: #6391f4"
                                @click="
                                  props.row.amount != null &&
                                  props.row.amount > 0
                                    ? props.row.amount--
                                    : ''
                                "
                              />
                            </div>
                            <div
                              class="row col-2 justify-center input-quantidade-container"
                              style="border-bottom: 1px solid #505050"
                            >
                              <q-input
                                class="input-quantidade"
                                borderless
                                dense
                                type="number"
                                v-model="props.row.amount"
                                min="0"
                              />
                            </div>
                            <div class="q-ml-sm">
                              <q-icon
                                name="arrow_right"
                                class="arrow"
                                style="background: #6391f4"
                                @click="
                                  props.row.amount == null
                                    ? (props.row.amount = 1)
                                    : props.row.amount++
                                "
                              />
                            </div>
                            <div class="q-ml-md">
                              <q-btn
                                :text-color="
                                  isProdutoSelecionado(props.row.id)
                                    ? 'black'
                                    : ''
                                "
                                :color="
                                  isProdutoSelecionado(props.row.id)
                                    ? 'accent'
                                    : 'primary'
                                "
                                label="Selecionar"
                                @click="toggleSelecao(props.row)"
                                :disable="isProdutoSelecionado(props.row.id)"
                                no-caps
                                dense
                                size="11px"
                                :icon="
                                  isProdutoSelecionado(props.row.id)
                                    ? 'check_circle_outline'
                                    : 'add_circle_outline'
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:body="props">
            <q-tr
              :class="{ 'selected-row': isProdutoSelecionado(props.row.id) }"
            >
              <q-td>
                <q-btn
                  class="q-ml-md"
                  :icon="isProdutoSelecionado(props.row.id) ? 'close' : 'add'"
                  :color="
                    isProdutoSelecionado(props.row.id) ? 'red' : 'primary'
                  "
                  :disable="false"
                  no-caps
                  round
                  dense
                  @click="toggleSelecao(props.row)"
                />
              </q-td>
              <q-td>
                <span>{{ props.row?.code }}</span>
              </q-td>
              <q-td>
                <div
                  v-if="
                    props.row.product_images &&
                    props.row.product_images.length != 0
                  "
                  class="img-container"
                >
                  <q-img
                    :src="props.row.product_images[0].url"
                    fit="contain"
                    style="max-width: 100%; height: 45px"
                  />
                </div>
                <div class="img-container" v-else>
                  <span class="img-normal"></span>
                </div>
              </q-td>
              <q-td style="white-space: normal">
                <span>{{ props.row?.name }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.unid_medida || "-" }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.category_name || "-" }}</span>
              </q-td>
              <q-td>
                <span>{{ formatarPreco(props.row.price) }}</span>
              </q-td>
              <q-td>
                <span>{{ formatarEstoque(props.row) }}</span>
              </q-td>
              <q-td>
                <q-input
                  dense
                  outlined
                  type="number"
                  style="width: 60px"
                  v-model="props.row.amount"
                  min="0"
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <div class="row justify-start q-mt-md">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :direction-links="true"
            size="sm"
            :max-pages="6"
          />
        </div>
      </div>
    </div>

    <div class="q-mt-xl q-mb-lg" v-if="selected.length > 0">
      <q-table
        :grid="$q.screen.lt.sm"
        table-header-class="bg-accent text-width-bold"
        :columns="columns2"
        class="tabela-tamanho-fixo"
        :rows="selected"
        no-data-label="Nenhum produto encontrado."
        hide-pagination
        :rows-per-page-options="[0]"
        :class="{ 'my-sticky-dynamic': !mobile }"
        dense
        flat
      >
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Produtos Selecionados</span
          >
        </template>
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
            <div class="row card">
              <div class="col-3 q-mr-sm text-center q-mt-md">
                <div
                  v-if="
                    props.row.product_images &&
                    props.row.product_images.length != 0
                  "
                  class="img-container-grid q-ml-sm"
                >
                  <q-img
                    :src="props.row.product_images[0].url"
                    fit="contain"
                    class="img-grid"
                  />
                </div>
                <div class="img-container-grid q-ml-sm" v-else>
                  <span class="img-grid"></span>
                </div>
              </div>
              <div class="col">
                <q-card-section class="row text-brand-5 text-grid-table">
                  <div class="col-12" style="margin-bottom: 3px">
                    <span><strong>Código:</strong> {{ props.row?.code }}</span>
                    <span class="q-ml-sm"
                      ><strong>Nome:</strong> {{ props.row?.name }}</span
                    >
                  </div>
                  <div class="col-12" style="margin-bottom: 3px">
                    <span
                      ><strong>Estoque:</strong>
                      {{ formatarEstoque(props.row) }}</span
                    >
                  </div>
                  <div class="col-12">
                    <div class="col-12">
                      <div class="text-brand-5 btn-grid-container">
                        <div class="row col-12 items-center">
                          <div class="q-mr-sm">
                            <q-icon
                              name="arrow_left"
                              class="arrow"
                              style="background: #6391f4"
                              @click="
                                props.row.amount != null && props.row.amount > 0
                                  ? props.row.amount--
                                  : ''
                              "
                            />
                          </div>
                          <div
                            class="row col-2 justify-center input-quantidade-container"
                            style="border-bottom: 1px solid #505050"
                          >
                            <q-input
                              class="input-quantidade"
                              borderless
                              dense
                              type="number"
                              v-model="props.row.amount"
                              min="0"
                            />
                          </div>
                          <div class="q-ml-sm">
                            <q-icon
                              name="arrow_right"
                              class="arrow"
                              style="background: #6391f4"
                              @click="
                                props.row.amount == null
                                  ? (props.row.amount = 1)
                                  : props.row.amount++
                              "
                            />
                          </div>
                          <div class="row col justify-center q-ml-xl">
                            <div>
                              <q-icon
                                name="close"
                                style="
                                  font-size: 28px;
                                  margin: 0px 0px 3px 0px;
                                  cursor: pointer;
                                "
                                color="red"
                                @click="removerProduto(props.row.id)"
                              ></q-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </q-card-section>
              </div>
            </div>
          </div>
        </template>
        <template #body-cell-selecionar="props">
          <q-td :props="props">
            <q-btn
              round
              no-caps
              color="red"
              dense
              icon="close"
              @click="removerProduto(props.row.id)"
            />
          </q-td>
        </template>
        <template #body-cell-imagem="props">
          <q-td :props="props">
            <div
              v-if="
                props.row.product_images && props.row.product_images.length != 0
              "
              class="img-container"
            >
              <q-img
                :src="props.row.product_images[0].url"
                fit="contain"
                style="max-width: 100%; height: 45px"
              />
            </div>
            <div class="img-container" v-else>
              <span class="img-normal"></span>
            </div>
          </q-td>
        </template>
        <template #body-cell-codigo="props">
          <q-td :props="props">
            <span>{{ props.row?.code }}</span>
          </q-td>
        </template>
        <template #body-cell-nome="props">
          <q-td :props="props">
            <span>{{ props.row?.name }}</span>
          </q-td>
        </template>
        <template #body-cell-estoque="props">
          <q-td :props="props">
            <span>{{ formatarEstoque(props.row) }}</span>
          </q-td>
        </template>
        <template #body-cell-quantidade="props">
          <q-td :props="props">
            <div>
              <q-input
                v-model.number="props.row.amount"
                type="number"
                style="width: 60px; max-width: 100px"
                outlined
                dense
                min="0"
              />
            </div>
          </q-td>
        </template>
      </q-table>
    </div>

    <div
      class="row q-mt-lg text-brand-5 text-weight-bold text-body container-observacao"
    >
      <div class="col-8 text-area-input">
        <div
          style="font-weight: 100"
          class="q-ml-sm text-brand-1 no-margin-no-padding"
        >
          Observações
        </div>
        <q-input
          type="textarea"
          dense
          outlined
          v-model="requisicaoObservacao"
        />
      </div>
      <div
        v-if="
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'vouchers-razao-criacao'
          ) != -1
        "
        class="q-mt-lg text-brand-5 text-weight-bold"
      >
        <span
          style="font-weight: 100"
          class="row col-12 text-brand-1 texto-autenticacao"
          >Selecione o Motivo para a Solicitação dessa requisição
          <span style="color: #8a8a8a" class="q-ml-sm">(Opcional)</span></span
        >
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Perda"
          val="Perda"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Roubo"
          val="Roubo"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Desgaste Natural"
          val="Desgaste Natural"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Desgaste Precoce"
          val="Desgaste Precoce"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Outros"
          val="Outros"
          :size="mobile ? 'sm' : 'lg'"
        />
      </div>
      <div
        v-if="dados.motivoRequisicao == 'Outros'"
        class="col-md-8 col-sm-6 col-xs-6"
      >
        <div class="texto-titulo-input">Digite o motivo da retirada</div>
        <q-input
          v-model="dados.motivoRequisicaoOutros"
          dense
          outlined
          class="select"
        />
      </div>
      <div class="row col-12 q-mt-md btn-requisicao-container">
        <q-btn
          class="btn-requisicao"
          label="Abrir Requisição"
          no-caps
          :disable="criarRequisicao || selected.length === 0"
          style="background-color: #21324a; border-radius: 8px; color: white"
          icon="add"
          @click="abrirRequisicao()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import { watchDebounced } from "@vueuse/core";

const columns2 = [
  {
    name: "selecionar",
    label: "Remover",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "imagem",
    label: "Imagem",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
    sortable: true,
    style: "white-space: normal",
  },
  {
    name: "estoque",
    label: "Estoque",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "quantidade",
    label: "QTD",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
];

export default {
  name: "NovaRequisicaoTabelasNew",
  props: {
    unidade: {
      type: Number,
      require: true,
    },
    centroCustoId: {
      type: Number,
      require: true,
    },
    userLogadoId: {
      type: Number,
      require: true,
    },
  },
  setup(props) {
    const columns = ref([
      {
        name: "selecionar",
        label: "Selecionar",
        align: "left",
        sortable: false,
        style: "width: 50px",
      },
      {
        name: "codigo",
        label: "Código",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "imagem",
        label: "Imagem",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "nome",
        label: "Descrição",
        align: "left",
        sortable: true,
        style: "white-space: normal",
      },
      {
        name: "unid_medida",
        label: "Unid. Medida",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "categoria",
        label: "Categoria",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "preco",
        label: "Preço",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "estoque",
        label: "Estoque",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "quantidade",
        label: "QTD",
        align: "left",
        sortable: false,
        style: "white-space: normal; width: 80px",
      },
    ]);

    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();
    const listaProdutos = ref([]);
    const filtrarProduto = ref("");
    let loading = ref(false);
    const selected = ref([]);
    const disable = ref(false);
    const dados = ref({
      motivoRequisicao: "",
      motivoRequisicaoOutros: undefined,
    });
    const criarRequisicao = ref(false);
    const requisicaoObservacao = ref();
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 10,
    });
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarProdutos = async () => {
      loading.value = true;
      try {
        let response = await store.dispatch("requisicao/listarProdutos", {
          vendor_id: props.unidade,
          per_page: 50,
          search: filtrarProduto.value,
          has_ca: "no",
        });

        let produtos = response.data.results.data.products || [];

        listaProdutos.value = produtos.map((produto) => ({
          ...produto,
          ca_codigo: produto?.pivot?.ca?.code,
          category_name: produto?.pivot?.product_category?.code || "-",
          unid_medida: produto?.stock?.[0]?.pivot?.measurement_unit || "-",
          price: produto?.pivot?.price,
          amount: 0,
        }));

        loading.value = false;
      } catch (error) {
        console.error("Erro ao listar produtos:", error);
        loading.value = false;
      }
    };

    const removerProduto = async (id) => {
      selected.value = selected.value.filter((produto) => produto.id != id);
    };

    const formatarEstoque = (row) => {
      if (row?.stock && row.stock.length > 0 && row.stock[0]?.pivot?.amount) {
        return parseFloat(row.stock[0].pivot.amount).toFixed(2);
      }
      return "0.00";
    };

    const formatarPreco = (price) => {
      if (price) {
        return `R$ ${parseFloat(price).toFixed(2)}`;
      }
      return "R$ 0.00";
    };

    const abrirRequisicao = async () => {
      criarRequisicao.value = true;

      if (!props.unidade || props.unidade === "") {
        criarRequisicao.value = false;
        quasar.notify({
          message: "Selecione uma Unidade para criar a Requisição.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        return;
      }

      if (!props.centroCustoId) {
        criarRequisicao.value = false;
        quasar.notify({
          message: "Selecione um Centro de Custo para criar a Requisição.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        return;
      }

      if (selected.value.length === 0) {
        criarRequisicao.value = false;
        quasar.notify({
          message: "Selecione pelo menos um produto para criar a Requisição.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        return;
      }

      const centroCustoId =
        typeof props.centroCustoId === "object"
          ? props.centroCustoId.id
          : props.centroCustoId;

      try {
        await store.dispatch("requisicao/criarRequisicao", {
          cost_center_id: centroCustoId,
          description: requisicaoObservacao.value,
          plantiff_id: props.userLogadoId,
          products: selected.value,
          vendor_id: props.unidade,
          voucher_reason:
            dados.value.motivoRequisicao != ""
              ? dados.value.motivoRequisicao == "Outros"
                ? dados.value.motivoRequisicaoOutros
                : dados.value.motivoRequisicao
              : undefined,
        });

        resetarValores();
        quasar.notify({
          message: "Requisição criada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        criarRequisicao.value = false;
        router.push({ name: "requisicao-lista" });
      } catch (error) {
        console.error("Erro ao criar requisição:", error);
        criarRequisicao.value = false;
        quasar.notify({
          message: error?.response?.data?.message || "Erro ao criar Requisição",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    const resetarValores = async () => {
      requisicaoObservacao.value = "";
      selected.value = [];
      listaProdutos.value = [];
      dados.value.motivoRequisicao = "";
      dados.value.motivoRequisicaoOutros = undefined;
    };

    const isProdutoSelecionado = (id) => {
      return selected.value.some((produto) => produto.id === id);
    };

    const toggleSelecao = (produto) => {
      if (isProdutoSelecionado(produto.id)) {
        selected.value = selected.value.filter((p) => p.id !== produto.id);
      } else {
        selected.value.push(produto);
      }
    };

    watchDebounced(
      () => filtrarProduto.value,
      () => {
        listarProdutos();
      },
      { debounce: 1000 }
    );

    watch(
      () => props.unidade,
      () => {
        listaProdutos.value = [];
        selected.value = [];
        if (props.unidade && props.centroCustoId) {
          listarProdutos();
        }
      }
    );

    watch(
      () => props.centroCustoId,
      () => {
        listaProdutos.value = [];
        selected.value = [];
        if (props.unidade && props.centroCustoId) {
          listarProdutos();
        }
      }
    );

    onMounted(() => {
      if (props.unidade && props.centroCustoId) {
        listarProdutos();
      }
    });

    return {
      columns,
      listaProdutos,
      filtrarProduto,
      loading,
      selected,
      store,
      removerProduto,
      criarRequisicao,
      abrirRequisicao,
      disable,
      requisicaoObservacao,
      mobile,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      dados,
      columns2,
      formatarEstoque,
      formatarPreco,
      isProdutoSelecionado,
      toggleSelecao,
    };
  },
};
</script>

<style scoped>
.sticky-header-table :deep(thead tr th) {
  position: sticky !important;
  top: 0 !important;
  z-index: 999 !important;
  background-color: #eef3fe !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  color: #202020 !important;
  border-bottom: 2px solid #ddd !important;
}

.sticky-header-table :deep(.q-table__top) {
  background-color: #ffffff;
}

.sticky-header-table :deep(.q-table__middle) {
  max-height: 500px;
  overflow-y: auto;
}

.sticky-header-table :deep(tbody) {
  overflow-y: auto;
}

.img-container {
  border: 2px solid gray;
  border-radius: 5px;
  font-weight: bold;
  width: 50px;
  height: 50px;
}

.img-normal {
  max-width: 100%;
  height: 100%;
}

.selected-row {
  background-color: #e3f2fd !important;
}

@media only screen and (max-width: 635px) {
  .container {
    margin: 30px 0 0 0;
  }
  .text-grid-table {
    font-size: 11px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .btn-grid-container {
    padding: 0;
    margin: 0;
  }
  .img-container-grid {
    border: 2px solid #b4b4b4;
    border-radius: 5px;
    font-weight: bold;
    width: 90px;
    height: 110px;
  }
  .img-grid {
    max-width: 100%;
    height: 100%;
  }
  .input-quantidade {
    margin: 0px;
    padding-left: 11px;
    font-size: 14px;
  }
  .input-quantidade-container {
    margin: 0px 0px 0px 0px;
    padding: 0px;
    height: 32px;
  }
  .text-area-input {
    width: 100%;
  }
  .btn-requisicao-container {
    margin: 15px 0 0 5px;
  }
  .btn-requisicao {
    margin: 0 8px 0 0;
    padding: 8px 10px 8px 5px;
    font-size: 13px !important;
    width: 171px;
    border-radius: 5px;
  }
  .container-observacao {
    margin: 20px 0px 0px 0px;
  }
  .arrow {
    color: white;
    font-size: 25px;
    border-radius: 5px;
    cursor: pointer;
  }
}

@media only screen and (max-width: 368px) {
  .arrow {
    color: white;
    font-size: 21px;
    border-radius: 5px;
    cursor: pointer;
  }
}

.arrow {
  color: white;
  font-size: 25px;
  border-radius: 5px;
  cursor: pointer;
}

.my-sticky-dynamic {
  max-height: 600px;
  overflow-y: auto;
}
</style>
